import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Navigate, Link } from 'react-router-dom';
import '../Profile.css';
import Post from "../components/Post";
import { Button } from 'react-bootstrap';

const CompanyProfile = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const echoUser = localStorage.getItem('echo_user');
    const userLvl = Number(localStorage.getItem('fw_user_lvl') || 0);
    const admin = userLvl > 1;

    const [companyData, setCompanyData] = useState(null);
    const [companyPosts, setCompanyPosts] = useState([]);
    const [viewMode, setViewMode] = useState('timeline');
    const [redirect, setRedirect] = useState(null);
    const [followed, setFollowed] = useState(0);
    const [flwBtn, setFlwBtn] = useState(false);
    const [loading, setLoading] = useState(true);
    const [onlineUsers, setOnlineUsers] = useState([]);

    const fullUrl = (path) => {
        if (!path) return null;
        return path.startsWith('http') ? path : `https://fantasyworldtrpg.cz${path}`;
    };

    const toggleFollow = async () => {
        setFlwBtn(true);
        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/follow_toggle.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ user: echoUser, target: id })
            });
            const data = await res.json();
            if (data.success) {
                setFollowed(data.followed);
            }
        } catch (e) {
            console.error("Chyba při sledování firmy:", e);
        } finally {
            setFlwBtn(false);
        }
    };

    useEffect(() => {
        if (!id) return;

        const loadData = async () => {
            setLoading(true);

            try {
                const res = await fetch('https://api.fantasyworldtrpg.cz/echo/company.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id }),
                });
                const company = await res.json();
                if (company.status === 'success') {
                    setCompanyData(company.data);
                } else {
                    setCompanyData(null);
                }

                const resPosts = await fetch('https://api.fantasyworldtrpg.cz/echo/companyposts.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ company: id }),
                });
                const postsData = await resPosts.json();
                if (postsData.status === 'success') {
                    setCompanyPosts(postsData.posts);
                }

                const flwRes = await fetch('https://api.fantasyworldtrpg.cz/echo/check_follow.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ user: echoUser, target: id })
                });
                const flwData = await flwRes.json();
                if (flwData.success) {
                    setFollowed(flwData.followed);
                }
            } catch (e) {
                console.error("Chyba při načítání firmy:", e);
                setCompanyData(null);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [id]);

    if (redirect) return <Navigate to={redirect} replace />;
    if (loading) return <div className="text-center my-5">⏳ Načítání profilu firmy...</div>;
    if (!companyData) return <div className="text-center my-5 text-danger">❌ Firma nenalezena</div>;

    return (
        <div className="container py-5 my-5" key={id}>
            <div className="row g-4">
                <div className="col-md-4 text-center">
                    <img src={fullUrl(companyData.image)} alt="logo" className="rounded-circle shadow profile-photo mb-3" />
                    <h4 className="mb-0">{companyData.title}</h4>

                    {/*companyData.followers && (
                        <p className="mt-2">
                            <i className="bi bi-people-fill"></i> Sledující: {companyData.followers}
                        </p>
                    )*/}

                    {/*companyData.id != echoUser && (
                        <Button disabled={flwBtn} size="sm" variant={followed === 1 ? "secondary" : "danger"} onClick={toggleFollow}>
                            {followed === 1 ? (
                                <><i className="bi bi-eye-slash"></i> Přestat sledovat</>
                            ) : (
                                <><i className="bi bi-eye-fill"></i> Sledovat</>
                            )}
                        </Button>
                    )*/}
                </div>

                <div className="col-md-8">
                    <h5 className="text-danger mb-3">O firmě</h5>
                    <p className="mb-1"><i className="bi bi-person-fill-gear text-primary me-2" /> Majitel ID: {companyData.owner}</p>
                    {companyData.description && (
                        <p><i className="bi bi-info-circle me-2" /> {companyData.description}</p>
                    )}

                    {admin && (
                        <div className="mt-4 p-3 bg-light rounded shadow-sm">
                            <h6 className="mb-2">Admin informace</h6>
                            <p className="mb-1">ID firmy: <strong>{companyData.id}</strong></p>
                            <Link target="_blank" to={`https://fantasyworldtrpg.cz/postava/${companyData.owner}`} className="btn-link">Zobrazit postavu majitele</Link>
                        </div>
                    )}
                </div>
            </div>

            <div className="mt-5">
                <div className="d-flex justify-content-center gap-2 mb-4">
                    <button className={`btn ${viewMode === 'timeline' ? 'btn-danger' : 'btn-outline-danger'}`} onClick={() => setViewMode('timeline')}>
                        <i className="bi bi-list"></i> Timeline ({companyPosts.length})
                    </button>
                    <button className={`btn ${viewMode === 'gallery' ? 'btn-danger' : 'btn-outline-danger'}`} onClick={() => setViewMode('gallery')}>
                        <i className="bi bi-grid-3x3-gap-fill"></i> Galerie
                    </button>
                </div>

                {viewMode === 'timeline' ? (
                    <>
                        {companyPosts && companyPosts.map((post, index) => (
                            <Post key={post.id || index} post={post} onlineUsers={onlineUsers} company={companyData} />
                        ))}
                    </>
                ) : (
                    <div className="row g-2">
                        {companyPosts && companyPosts
                            .filter(post => post.image)
                            .map((post, index) => (
                                <div className="col-4 col-md-3 col-lg-2" key={post.id || index}>
                                    <div
                                        className="position-relative"
                                        style={{
                                            width: '100%',
                                            paddingBottom: '100%',
                                            overflow: 'hidden',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => navigate(`/post/${post.id}`)}
                                    >
                                        <img
                                            src={post.image.startsWith('http') ? post.image : `https://echo.fantasyworldtrpg.cz${post.image}`}
                                            alt="Galerie"
                                            loading="lazy"
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CompanyProfile;
